export enum SignatureStatusType {
    Pending = 0,
    Complete = 1,
    Expired = 2,
}

export enum SignatureRequestStatusType {
    Draft = 0,
    Published = 1,
    Completed = 2,
    Expired = 3,
    Cancelled = 4,
}
